import { FeatureMainProps } from '../../../../components/Features/FeatureMain/types'

export const pageData: FeatureMainProps = {
    accentColor: '#b08d4a',
    pc: {
        background: '/features/umito-20260701/hero.jpg',
        eyebrow: '求人特集',
        titleLines: ['UMITO', '熱海本邸'],
        contentsColor: '#1f4a7a',
    },
    hero: {
        image: '/features/umito-20260701/hero.jpg',
        alt: 'UMITO熱海本邸',
        panel: '/features/umito-20260701/hero_panel.jpg',
        analyticsLabel: 'FV',
    },
    headline: {
        title: [
            {
                // コンテナ幅(≒ min(100vw, 430px) − 40px)に連動させ、15文字を常に1行で表示。
                // 現状の30pxより小さく、PCは24pxで頭打ち。文言の文字数を変える場合は割る数(15)も合わせる。
                text: '「旅するように、仕事をしよう」',
                fontSize: 'clamp(16px, calc((100vw - 48px) / 15), 24px)',
            },
        ],
        paragraphs: [
            {
                text: '「UMITO」が、共に働く仲間と共有したいと願う、ただ一つの価値観です。',
            },
        ],
        accent: '遠方からの応募大歓迎！転居補助あり',
    },
    thumbnail: {
        image: '/features/umito-20260701/top_sub.jpg',
        alt: 'UMITO熱海本邸',
    },
    featuresTitle: ['UMITOで働く魅力'],
    featuresTitleAnalyticsLabel: 'CT_Charm_働く魅力-タイトル',
    features: [
        {
            heading: ['一流のサービススキルが磨ける'],
            body: [
                'UMITOが追求するのは、お客様一人ひとりに深く向き合う「1to1サービス」です。全室スイート仕様のスモールラグジュアリーホテルへ、世界中から訪れる富裕層のゲストに対し、マニュアルのない、パーソナライズされたおもてなしを提供します。',
            ],
            image: '/features/umito-20260701/section_01.jpg',
            analyticsLabel: 'CT_Charm_働く魅力-1st',
        },
        {
            heading: ['一流の世界で通用する人財に成長できる'],
            body: [
                '厨房を率いるのは、ミシュラン2つ星シェフが監修する「naoto.K」の哲学を受け継ぐ、一流の料理人。調理とサービス、それぞれのプロフェッショナルが互いの仕事を深くリスペクトし、少数精鋭のチームならではの密な連携で成長できます。',
            ],
            image: '/features/umito-20260701/section_02.jpg',
            analyticsLabel: 'CT_Charm_働く魅力-2nd',
        },
        {
            heading: ['最高のロケーション'],
            body: [
                '都心からわずか1時間ほどのリゾート地、熱海。どこまでも続く穏やかな海の景色が、すぐそばにあります。仕事終わりに熱海の街を散策したり、休日に温泉でリフレッシュしたり。',
                'そんな、心豊かなライフスタイルを、ここでは実現できます。',
            ],
            image: '/features/umito-20260701/section_03.jpg',
            analyticsLabel: 'CT_Charm_働く魅力-3rd',
        },
    ],
    floatingCta: {
        label: '求人一覧を見る',
        analyticsLabel: 'CT_Jobinformation_追従CTA',
    },
    jobs: {
        eyebrow: 'pickup',
        title: ['UMITO 求人特集'],
        analyticsLabel: 'CT_Jobinformation_求人特集-タイトル',
        categories: [
            {
                id: 'cook',
                categoryLabel: '料理人',
                variant: 'list',
                description:
                    '一流の料理人が率いる少数精鋭のチームで、調理とサービス、それぞれをプロフェッショナルとして経験・成長できます',
                jobs: [
                    {
                        offerId: '119842',
                        badgeLabel: '料理長・料理長候補',
                        title: '【調理即戦力急募!!高収入*転居補助】熱海のスモールラグジュアリーホテル',
                        brandName: 'UMITO熱海本邸 Restaurant',
                        brandLogo: '/features/umito-20260701/logo.jpg',
                        salary: '38~52',
                        salaryUnit: '月収',
                        prefecture: '静岡県',
                        city: '熱海',
                        image: '/features/umito-20260701/umito-card-01.jpg',
                        href: 'https://foods-labo.com/offers/119842',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-料理長候補-1st',
                    },
                    {
                        offerId: '119843',
                        badgeLabel: 'キッチンスタッフ',
                        title: '【未経験OK*転居補助あり*一流の技術を学ぶ】熱海のラグジュアリーホテル',
                        brandName: 'UMITO熱海本邸 Restaurant',
                        brandLogo: '/features/umito-20260701/logo.jpg',
                        salary: '33~38',
                        salaryUnit: '月収',
                        prefecture: '静岡県',
                        city: '熱海',
                        image: '/features/umito-20260701/umito-card-02.jpg',
                        href: 'https://foods-labo.com/offers/119843',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-キッチンスタッフ候補-1st',
                    },
                ],
            },
            {
                id: 'service',
                categoryLabel: 'サービススタッフ',
                variant: 'list',
                description:
                    'UMITOが追求するのは、お客様一人ひとりに深く向き合う「1to1サービス」で、一流のサービススキルが磨けます',
                jobs: [
                    {
                        offerId: '105288',
                        badgeLabel: 'マネージャー・支配人・副支配人・女将',
                        title: '《月給38万円〜｜転居補助あり》UMITO熱海本邸の支配人・MGR候補',
                        brandName: 'UMITO熱海本邸',
                        brandLogo: '/features/umito-20260701/logo.jpg',
                        salary: '38~52',
                        salaryUnit: '月収',
                        prefecture: '静岡県',
                        city: '熱海',
                        image: '/features/umito-20260701/umito-card-03.jpg',
                        href: 'https://foods-labo.com/offers/105288',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-マネージャー候補-1st',
                    },
                    {
                        offerId: '105287',
                        badgeLabel: '宿泊全般',
                        title: '【福利厚生充実*転居補助あり】スモールラグジュアリーのサービススタッフ',
                        brandName: 'UMITO熱海本邸',
                        brandLogo: '/features/umito-20260701/logo.jpg',
                        salary: '27~38',
                        salaryUnit: '月収',
                        prefecture: '静岡県',
                        city: '熱海',
                        image: '/features/umito-20260701/umito-card-04.jpg',
                        href: 'https://foods-labo.com/offers/105287',
                        analyticsLabel:
                            'CT_Jobinformation_求人例-宿泊全般候補-1st',
                    },
                ],
            },
        ],
    },
}
